import server from "./server";

export const getSocialLinksApi = async () => {
  const response = await server().get("/socialLinks");
  return response.data;
};

export const getSocialLinkApi = async ({ id }) => {
  const response = await server().get(`/socialLinks/${id}`);
  return response.data;
};

export const createSocialLinkApi = async ({ data }) => {
  const response = await server().post("/socialLinks", data);
  return response.data;
};

export const updateSocialLinkApi = async ({ id, data }) => {
  const response = await server().put(`/socialLinks/${id}`, data);
  return response.data;
};

export const deleteSocialLinkApi = async ({ id }) => {
  const response = await server().delete(`/socialLinks/${id}`);
  return response.data;
};
